







import {
	defineComponent,
	PropType,
} from '@vue/composition-api';
import YoutubeEmbed from '@front-app/components/video/YoutubeEmbed.vue';
import { LearningStep } from '../Model';

export default defineComponent({
	components: { YoutubeEmbed },
	props: {
		step: {
			type: Object as PropType<LearningStep>,
			required: true,
		},
	},
});
